import List from "./pages/List";
import WizardRoute from "./pages/Wizard/WizardRoute";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["INVOICE_MODULE"],
  },
  {
    path: ":id/*",
    element: WizardRoute,
    permissions: ["INVOICE_MODULE"],
  },
];

export default routes;
